"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBaseDataRepPrimType = exports.isBasePrimType = exports.isPrimTypeTag = void 0;
var types_1 = require("../types.js");
function isPrimTypeTag(t) {
    switch (t) {
        case types_1.PrimType.Alias:
        case types_1.PrimType.AsData:
        case types_1.PrimType.BS:
        case types_1.PrimType.bls12_381_G1_element:
        case types_1.PrimType.bls12_381_G2_element:
        case types_1.PrimType.bls12_381_MlResult:
        case types_1.PrimType.Bool:
        case types_1.PrimType.Data:
        case types_1.PrimType.Delayed:
        case types_1.PrimType.Int:
        case types_1.PrimType.Lambda:
        case types_1.PrimType.List:
        case types_1.PrimType.Pair:
        case types_1.PrimType.Str:
        case types_1.PrimType.Struct:
        case types_1.PrimType.Sop:
        case types_1.PrimType.Unit:
            return true;
        default:
            return false;
    }
}
exports.isPrimTypeTag = isPrimTypeTag;
function isBasePrimType(t) {
    switch (t) {
        case types_1.PrimType.BS:
        case types_1.PrimType.bls12_381_G1_element:
        case types_1.PrimType.bls12_381_G2_element:
        case types_1.PrimType.bls12_381_MlResult:
        case types_1.PrimType.Bool:
        case types_1.PrimType.Data:
        case types_1.PrimType.Int:
        case types_1.PrimType.Str:
        case types_1.PrimType.Unit:
            return true;
        default:
            return false;
    }
}
exports.isBasePrimType = isBasePrimType;
function isBaseDataRepPrimType(t) {
    switch (t) {
        case types_1.PrimType.BS:
        case types_1.PrimType.Bool:
        case types_1.PrimType.Data:
        case types_1.PrimType.Int:
        case types_1.PrimType.Str:
        case types_1.PrimType.Unit:
            return true;
        default:
            return false;
    }
}
exports.isBaseDataRepPrimType = isBaseDataRepPrimType;
